__webpack_require__.p = "https://relaunch.ratis.de/wp-content/plugins/wordpress-entschaedigungsmanager-tool/dist/";